import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Mutation, Query } from 'react-apollo';
import { Formik } from 'formik';
import { ingredientValidationSchema } from '../../validation/ingredient';
import IngredientForm from '~/components/ingredientForm/ingredientForm';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const geIngredientQuery = gql`
  query ingredient($id: Int!) {
    ingredient(id: $id) {
      id
      name
      customsName
      description
      type
      measurementType
      isTracked
      products {
        id
        product {
          id
          name
        }
      }
    }
  }
`;

export const updateIngredientsMutation = gql`
  mutation updateIngredient(
    $id: Int!
    $name: String!
    $customsName: String
    $description: String
    $type: IngredientType!
    $measurementType: IngredientMeasurementType!
    $isTracked: Boolean
  ) {
    updateIngredient(
      id: $id
      name: $name
      customsName: $customsName
      description: $description
      type: $type
      measurementType: $measurementType
      isTracked: $isTracked
    ) {
      id
      name
      breweryId
      description
      type
      measurementType
    }
  }
`;

export class IngredientEdit extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same silly update Apollo issue I keep running into
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;

    return (
      <Query query={geIngredientQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { ingredient } = data;
          return (
            <div className="content">
              <Mutation mutation={updateIngredientsMutation}>
                {(updateIngredient, { error }) => (
                  <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={ingredient}
                    validationSchema={ingredientValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await updateIngredient({
                          variables: {
                            id,
                            ...values
                          }
                        });
                        history.push(`/ingredients/${id}?updated=true`);
                      } catch (err) {
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={IngredientForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(IngredientEdit));



// WEBPACK FOOTER //
// ./src/containers/ingredientEdit/ingredientEdit.jsx